import { IServiceHistory, IRepairOrderCondition, IOperation } from './dashboard.model';
import { Operation, RepairCondition, ServiceManager, VehicleServiceHistory } from './service-history';
import { DateTime } from 'luxon';

export class ServiceHistory implements IServiceHistory {
    vin: string;
    mileage: string;
    repairOrderNumber: string;
    repairOrderOpenDate: string;
    repairOrderCloseDate: string;
    serviceAdvisor: string;
    dealerNumber: string;
    repairOrderConditions: IRepairOrderCondition[];

    constructor(vin: string,
        mileage: string,
        repairOrderNumber: string,
        repairOrderOpenDate: string,
        repairOrderCloseDate: string,
        serviceAdvisor: string,
        dealerNumber: string,
        repairOrderConditions: IRepairOrderCondition[] = []) {

        this.vin = vin;
        this.mileage = mileage;
        this.repairOrderNumber = repairOrderNumber;
        this.repairOrderOpenDate = repairOrderOpenDate;
        this.repairOrderCloseDate = repairOrderCloseDate;
        this.serviceAdvisor = serviceAdvisor;
        this.dealerNumber = dealerNumber;
        this.repairOrderConditions = repairOrderConditions;
    }

    static getSerivceHistoryArray(vehicleServiceHistory: VehicleServiceHistory) {
        const vin = vehicleServiceHistory.vin;
        const serviceHistoryArray = [];
        vehicleServiceHistory.repairOrder.forEach(record => {
            serviceHistoryArray.push(new ServiceHistory(
                vin,
                record.miles,
                record.repairOrderNumber,
                DateTime.fromFormat(record.closeDate, 'yyyy-MM-dd').minus({ days: parseInt(record.openDays) }).toFormat('yyyy-MM-dd'),
                record.closeDate,
                this.getServiceAdvisor(record.serviceManager),
                record.repairOrderDealer?.dealerNumber,
                this.getRepairOrderCondition(record.repairCondition)
            ));
        });
        return serviceHistoryArray;
    }

    static getRepairOrderCondition(repairOrderConditions: RepairCondition[]): IRepairOrderCondition[] {
        const conditions: IRepairOrderCondition[] = [];
        if (repairOrderConditions && repairOrderConditions.length) {
            repairOrderConditions.forEach(element => {
                conditions.push(new RepairConditions(
                    element.conditionNumber,
                    this.getServiceOperation(element.operationList)
                ));
            });
        }
        return conditions;
    }

    static getServiceOperation(operations: Operation[]): IOperation[] {
        const serviceOperation: IOperation[] = [];
        if (operations && operations.length) {
            operations.forEach(operation => {
                serviceOperation.push(new ServiceOperation(
                    operation.opCodeNumber,
                    operation.opCodeDescription,
                    operation.serviceOperationsDescription,
                    operation.opCodeHours
                ));
            });
        }
        return serviceOperation;
    }

    static getServiceAdvisor(serviceManager: ServiceManager): string {
        if (serviceManager) {
            return `${serviceManager.name?.firstName || ''} ${serviceManager.name?.middleName || ''} ${serviceManager.name?.lastName || ''}`;
        } else {
            return;
        }
    }
}

export class RepairConditions implements IRepairOrderCondition {
    conditionNumber: string;
    operation: IOperation[];

    constructor(
        conditionNumber: string,
        operation: IOperation[] = []
    ) {
        this.conditionNumber = conditionNumber;
        this.operation = operation;
    }
}

export class ServiceOperation implements IOperation {
    opCodeNumber: string;
    opCodeDescription: string;
    serviceOperationDescription: string;
    opCodeHours: string;

    constructor(opCodeNumber: string,
        opCodeDescription: string,
        serviceOperationDescription: string,
        opCodeHours: string) {
        this.opCodeNumber = opCodeNumber;
        this.opCodeDescription = opCodeDescription;
        this.serviceOperationDescription = serviceOperationDescription;
        this.opCodeHours = opCodeHours;
    }
}
